// extracted by mini-css-extract-plugin
module.exports = {"divider":"PageDivider-module__divider___3aLTy"};